import { render, staticRenderFns } from "./addDriverDrawer.vue?vue&type=template&id=50b74a72&scoped=true&"
import script from "./addDriverDrawer.vue?vue&type=script&lang=js&"
export * from "./addDriverDrawer.vue?vue&type=script&lang=js&"
import style0 from "./addDriverDrawer.vue?vue&type=style&index=0&id=50b74a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b74a72",
  null
  
)

export default component.exports